import { render, staticRenderFns } from "./APIAuth.vue?vue&type=template&id=7fbafe2e&scoped=true&"
import script from "./APIAuth.vue?vue&type=script&lang=js&"
export * from "./APIAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbafe2e",
  null
  
)

export default component.exports